import { ProjectAnalysisAggregateLineItem } from "@interfaces/analysis";
import {
  SocialCommitmentTypeHour,
  SocialCommitmentTypeSpend,
  socialCommitmentTypeHourToString,
  socialCommitmentTypeSpendToString,
} from "@interfaces/commitment";
import { Grid } from "@mui/material";
import { StyledCard } from "@stories/atoms/StyledCard/StyledCard";
import { PieChart } from "@stories/molecules/PieChart/PieChart";

interface ProjectProgressProps {
  analysis: ProjectAnalysisAggregateLineItem;
  chartRef: React.MutableRefObject<HTMLDivElement[]>;
  setSelectedSocialProcurementType: (
    socialFactor: SocialCommitmentTypeHour | SocialCommitmentTypeSpend
  ) => void;
}

export const ProjectProgress = ({
  analysis,
  chartRef,
  setSelectedSocialProcurementType,
}: ProjectProgressProps) => {
  return (
    <>
      <Grid container spacing={2} sx={{ display: "flex" }}>
        {[0, 1, 2, 3, 4, 5, 6, 7].map((item) => {
          return (
            <Grid
              item
              xs={3}
              md={3}
              sm={12}
              sx={{
                display: "flex",
                alignContent: "center",
                justifyContent: "center",
                margin: "auto",
              }}
              justifyContent={"center"}
            >
              <StyledCard>
                <PieChart
                  ref={(element: HTMLDivElement) =>
                    chartRef.current.push(element)
                  }
                  onClick={() => {
                    setSelectedSocialProcurementType(
                      SocialCommitmentTypeSpend.LocalContent
                    );
                  }}
                  title={socialCommitmentTypeSpendToString(
                    SocialCommitmentTypeSpend.LocalContent
                  )}
                  data={{ target: 1, achieved: 1, allocated: 10, pcChange: 1 }}
                />
              </StyledCard>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};
